// Ported from case-desk src/components/BrandMark.tsx (commit 1d18e32) per das-web § 14, 2026-08-18.
import Box from '@mui/material/Box';

import { designTokens } from '../theme/tokens';

type BrandMarkProps = {
  logoUrl?: string;
};

/** The DAS mark, or the tenant logo when the bootstrap contract delivers one (das-web § 8.4). */
export function BrandMark({ logoUrl = designTokens.branding.defaultLogoUrl }: BrandMarkProps) {
  return (
    <Box
      alt=""
      aria-hidden
      component="img"
      src={logoUrl}
      sx={{
        display: 'block',
        height: designTokens.layout.brandMarkSize,
        objectFit: 'contain',
        width: designTokens.layout.brandMarkSize,
      }}
    />
  );
}
